<template>
	<div class="approveCount" v-loading="loading" element-loading-text="数据加载中...">
		<div class="text-bold text-df padding-xs">审批统计</div>
		<div class="count">
			<div class="topChart">
				<div class="item">
					<span class="text-gray text-sxs text-bold">预约中</span>
					<span class="circle">{{topData.yyz}}</span>
				</div>
				<div class="item">
					<span class="text-gray text-sxs text-bold">预约通过</span>
					<span class="circle">{{topData.yytg}}</span>
				</div>
				<div class="item">
					<span class="text-gray text-sxs text-bold">审核中</span>
					<span class="circle">{{topData.shz}}</span>
				</div>
				<div class="item">
					<span class="text-gray text-sxs text-bold">已发证</span>
					<span class="circle">{{topData.yfz}}</span>
				</div>
				<div class="item">
					<span class="text-gray text-sxs text-bold">采伐证数量</span>
					<span class="circle">{{topData.cfzsl}}</span>
				</div>
				<div class="item">
					<span class="text-gray text-sxs text-bold">集采厂数量</span>
					<span class="circle">{{topData.zccsl}}</span>
				</div>
			</div>
			<el-divider></el-divider>
			<div class="buttonChart">
				<div class="search">
					<el-select v-model="searchForm.timeType" @change="dateChange" placeholder="请选择时间区间" size="medium">
						<el-option label="本月" :value="1"></el-option>
						<el-option label="本年" :value="2"></el-option>
					</el-select>
					<el-date-picker
						size="medium"
						@change="timeChange"
						v-model="date"
						type="daterange"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					></el-date-picker>
				</div>
				<div class="chart">
					<div id="chart" class="item"></div>
					<div id="chart2" class="item"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { GetApprovalCount,GetApprovalChart } from '@/api/Ordered';
export default {
	data() {
		return {
			searchForm: {
				timeType: 1,
				startTime: '',
				endTime: ''
			}, //搜索表单
			loading: false, // 数据是否处于加载状态
			date: '',
			topData: {}, //顶部统计图数据
			bottomData:{},//底部统计图数据
		}
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.getApproveCount()
		this.getChart()
	},
	methods: {
		// 月份更改
		dateChange(){
			this.getApproveCount()
			this.getChart()
		},
		// 选择时间
		timeChange(e) {
			if (e) {
				this.searchForm.startTime = e[0];
				this.searchForm.endTime = e[1];
			} else {
				this.searchForm.startTime = '';
				this.searchForm.endTime = '';
			}
			
			this.getApproveCount()
			this.getChart()
		},
		// 获取审批统计数量
		getApproveCount(){
			this.loading = true
			GetApprovalCount().then(res=>{
				if(res.data.state==1){
					this.topData = res.data.data
				}
				this.loading = false
			})
		},
		
		// 获取统计图
		getChart(){
			let params = {
				timeType:this.searchForm.timeType,
				startTime:this.searchForm.startTime,
				endTime:this.searchForm.endTime
			}
			GetApprovalChart(params).then(res=>{
				if(res.data.state==1){
					this.bottomData = res.data.data
					this.initBottomChart()
				}
			})
		},
		
		// 初始化统计图数据
		initBottomChart() {
			let myChart = this.$echarts.init(document.getElementById('chart'));
			let myChart2 = this.$echarts.init(document.getElementById('chart2'));
			// 指定图表的配置项和数据
			let option = {
				title: {
					text: `预约通过历史统计图`,
					left: 'center'
				},
				xAxis: {
					type: 'category',
					data: this.bottomData.orderedName
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					bottom: 10,
					left: 'center',
					data: ['预约通过']
				},
				yAxis: {type: 'value'},
				series: [
					{
						name: '预约通过',
						type: 'line',
						stack: 'Total',
						data: this.bottomData.orderedCount
					},	
				]
			};
			let option2 = {
				title: {
					text: `已发证历史统计图`,
					left: 'center'
				},
				xAxis: {
					type: 'category',
					data: this.bottomData.licenseName
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					bottom: 10,
					left: 'center',
					data: ['发证数量']
				},
				yAxis: {type: 'value'},
				series: [
					{
						name: '发证数量',
						type: 'line',
						stack: 'Total',
						data: this.bottomData.licenseCount
					},	
				]
			};
			myChart.setOption(option);
			myChart2.setOption(option2);
		},
	}
};
</script>
<style lang="less" scoped>
.approveCount {
	height: 100%;
	.count {
		height: calc(100vh - 165px);
		margin: 30px 10px 10px 10px;
		display: flex;
		flex-direction: column;
		.topChart {
			display: flex;
			align-items: center;
			padding-bottom: 20px;
			.item {
				flex: 1;
				display: flex;
				flex-direction: column;
				align-items: center;
				.circle {
					width: 100px;
					height: 100px;
					border-radius: 50%;
					text-align: center;
					line-height: 100px;
					margin-top: 20px;
					border: 1px solid #ccc;
				}
			}
			.item2 {
				width: 50%;
				// height: 100%;
				ul {
					padding: 0;
					margin: 0;
					margin-top: 20px;
					width: 100%;
					// height: 100%;
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;
					li {
						// width: 40%;
						width: 200px;
						height: 200px;
						border:1px solid #ccc;
						border-radius: 50%;
						text-align: center;
						list-style: none;
						margin-bottom: 20px;
						font-size: 20px;
						font-weight: bold;
						line-height: 200px;
					}
				}
			}
		}
		.buttonChart {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			// width: 100%;
			.search {
				display: flex;
				align-items: center;
				padding: 10px;
				.el-select {
					margin-right: 30px;
					width: 220px;
				}
			}
			.chart {
				width: 100%;
				flex: 1;
				display: flex;
				.item {
					width: 50%;
					height: 100%;
				}
			}
			
		}
	}
}
</style>
<style lang="less">
/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #fff !important;
}
</style>
